import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './materialActionTypes';
import * as actions from './materialActions';
import * as endpoints from '../../services/endpoints';
import { errorHandler } from '../../helpers/errorHandler';

function* getMaterialSaga(action) {
  try {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const payload = {
      SessionUserId: String(sessionUserId),
    };
    const { data } = yield call(endpoints.getMaterials, payload);
    yield put(actions.getMaterialDataAction(data));
  } catch (e) {
    yield put(actions.getMaterialErrorAction(e));
    yield call(errorHandler, e, action.history, action.href);
  }
}

function* createMaterialSaga(action) {
  try {
    console.log('createMaterialSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Create material API payload:', payload);
    
    const { data } = yield call(endpoints.createMaterial, payload);
    console.log('Create material API response:', data);
    
    yield put(actions.createMaterialDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      setTimeout(() => {
        if (action.payload.navigate) {
          action.payload.navigate('/material');
        }
      }, 2000);
    }
    
  } catch (e) {
    console.error('createMaterialSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.createMaterialErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* updateMaterialSaga(action) {
  try {
    console.log('updateMaterialSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Update material API payload:', payload);
    
    const { data } = yield call(endpoints.updateMaterial, payload);
    console.log('Update material API response:', data);
    
    yield put(actions.updateMaterialDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getMaterialRequestAction());
      
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/material');
        }, 1000);
      }
    }
    
  } catch (e) {
    console.error('updateMaterialSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.updateMaterialErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* deleteMaterialSaga(action) {
  try {
    console.log('deleteMaterialSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Delete material API payload:', payload);
    
    const { data } = yield call(endpoints.deleteMaterial, payload);
    console.log('Delete material API response:', data);
    
    yield put(actions.deleteMaterialDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getMaterialRequestAction());
    }
    
  } catch (e) {
    console.error('deleteMaterialSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.deleteMaterialErrorAction(e));
    yield call(errorHandler, e);
  }
}

export function* materialSaga() {
  yield all([
    takeEvery(types.GET_MATERIAL_REQUEST, getMaterialSaga),
    takeEvery(types.CREATE_MATERIAL_REQUEST, createMaterialSaga),
    takeEvery(types.UPDATE_MATERIAL_REQUEST, updateMaterialSaga),
    takeEvery(types.DELETE_MATERIAL_REQUEST, deleteMaterialSaga),
  ]);
}